// CampaignTargetVehiclesForm.tsx
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Control, Controller, UseFormSetValue } from 'react-hook-form';
import { GroupPropertiesContainer } from '~/features/groups/components/GroupPropertiesContainer';
import { useFetchVehicleGroupsQuery } from '~/api/vehicleGroup/VehicleGroup.api';
import SelectOTA from '~/features/base/components/forms/ota/SelectOTA';
import NotFoundState from '@rio-cloud/rio-uikit/NotFoundState';
import { GROUPS_PATH } from '~/features/base/constants/routes';
import { openInNewTab } from '~/features/base/utils/openInNewTab';

interface CampaignTargetVehiclesFormProps {
    control: Control<any>;
    setValue: UseFormSetValue<any>;
    disabled?: boolean;
}

const CampaignTargetVehiclesForm: React.FC<CampaignTargetVehiclesFormProps> = ({
                                                                                   control,
                                                                                   setValue,
                                                                                   disabled = false
                                                                               }) => {
    const intl = useIntl();
    const { data: groups, refetch } = useFetchVehicleGroupsQuery({});
    const groupsOptions = groups?.map((group) => ({
        value: group.name,
        label: group.name,
        id: group.name
    }));

    return (
        <div className="campaign-target-vehicles-form">
            <div className="margin-bottom-20">
                <p className='text-color-gray'>
                    <FormattedMessage
                        id='intl-msg:campaign:targetGroup:description'/>
                    <span className={'text-decoration-underline'} style={{ cursor: 'pointer' }}
                          onClick={() => (openInNewTab(`/#${GROUPS_PATH}`))}> <FormattedMessage
                        id={'intl-msg:campaign:targetGroup:description:link'}/></span>
                </p>
            </div>
            <div className="margin-bottom-20">
                <Controller
                    control={control}
                    name="targetGroups"
                    rules={{
                        required: intl.formatMessage({ id: 'intl-msg:campaign:targetGroup:rule:atLeastOne' }),
                        validate: (value) => (value && value.length > 0) || intl.formatMessage({ id: 'intl-msg:campaign:targetGroup:rule:atLeastOne' })
                    }}
                    render={({ field, fieldState: { error } }) => (

                        <div>
                            <div
                                className={'display-flex flex-row gap-15 text-size-18 width-100pct align-items-center'}>
                                <div style={{ flex: '1 1 auto', width: '100%' }}>
                                    <SelectOTA
                                        hasError={!!error}
                                        errorMessage={error?.message}
                                        options={groupsOptions}
                                        value={[field.value]}
                                        onChange={(selectedOption) => {
                                            field.onChange(selectedOption?.value);
                                        }}
                                        placeholder={<FormattedMessage
                                            id='intl-msg:vehicleGroup:select'/>}/>
                                </div>
                                <span className={'rioglyph rioglyph-refresh'} style={{ cursor: 'pointer' }}
                                      onClick={() => refetch()}/>
                            </div>
                            {field.value  ? (
                                <GroupPropertiesContainer
                                    groupDesc={groups?.find(group => group.name === field.value)}
                                    groupName={field.value}
                                />
                            ) : (
                                <NotFoundState
                                    outerClassName='margin-top-20'
                                    fullWidth
                                    headline={<FormattedMessage id='intl-msg:campaign:NoGroupSelected'/>}
                                />
                            )}
                        </div>
                    )}
                />
            </div>
            <div className="margin-top-20">
                <div className="alert alert-info">
                    <i className="rioglyph rioglyph-info-sign margin-right-5" />
                    <FormattedMessage id='intl-msg:campaign:targetGroup:note'/>
                </div>
            </div>
        </div>
    );
};

export default CampaignTargetVehiclesForm;
